<template>
  <div :style="{...wrapStyle,...bgImageStyle}" @click="invite"></div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { common, componentBaseMixin } from '@tencent/ceiba-base-components';

export default {
  name: 'CSupercoreUserInvite',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'supercore-user-invite-',
      inviteCode: '',
    };
  },
  computed: {
    bgImageStyle() {
      return {
        backgroundImage: `url(${this.configurationData.bgImage || ''})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
      };
    },
    wrapStyle() {
      const fontStyle = this.styles.fontStyle || {};
      return {
        ...this.styles.base,
        ...fontStyle,
      };
    },
    isInvite() {
      return this.configurationData.isInvite || false;
    },
    callBackFlowId() {
      return this.configurationData.callBackFlowId || 0;
    },
  },
  async mounted() {
    await this.initialize();
    // await this.getInviteCode()
  },
  methods: {
    async initialize() {
      console.log('this.configurationData in supercore-user-invite = 1.0.15 ', this.configurationData);
    },
    async getInviteCode() {
      // if (!this.isLogin) {
      //   this.alert('请先登录');
      //   return;
      // }
      const params = {
        business: this.$actInfo.ast,
        activity: `${this.$actInfo.activity_id}`,
        ext: JSON.stringify({
          name: this.userInfo.nickName,
          avatar: this.userInfo.avatar || 'https://game.gtimg.cn/images/js/img/lottery/default_head.png',
          dynamicPageId: this.userInfo.dynamicPageId,
        }),

      };
      console.log('getInviteCode', this.userInfo, params);
      const response = await this.$requestInstance.post('Ceiba.PlaySrv/GetInviteCode', params);
      console.log('getInviteCode response = ', response);
      const { ret, data = {}  } = response || {};
      if (ret !== 0) {
        this.toast('获取个人邀请码失败');
        this.inviteCode = '';
        return;
      }
      const { invite_code: inviteCode } = data;
      console.log('get invite_code = ', inviteCode);
      this.inviteCode = inviteCode;

      return this.inviteCode;
    },
    async invite() {
      // if (this.$isInEditor) return ;
      this.handleClickEvent();
      if (!this.isLogin) {
        this.alert('请先登录');
        return;
      }
      // 前置条件
      if (this.configurationData.forceRole && !this.isRoleReady) {
        this.alert('未检测到角色，请先绑定角色');
        return  false;
      }
      const { preFlowId = 0 } = this.configurationData;
      if (preFlowId > 0) {
        const preCheckResponse = await this.flowRequest({
          flowId: preFlowId,
          params: {
            role: this.roleInfo,
          },
        });
        const { ret, msg, data = { ret: 0 } } = preCheckResponse || {};
        if (ret !== 0) {
          return this.$alert({ msg });
        }
        const { ret: resRet, msg: resMsg } = data;
        if (resRet !== 0) {
          return this.$alert({ msg: resMsg || '条件不满足,不能进行分享' });
        }
      }
      if (this.isInvite) {
        await this.getInviteCode();
      }
      let link = common.tool.setUrlParam(
        'c_invite_code', this.inviteCode,
        this.configurationData.link || window.location.href,
      );
      link = common.tool.setUrlParam('t', `${new Date().getTime()}`, link);
      console.log('inviteLink=', link);
      this.doShare({
        title: this.configurationData.title ||  this.shareConfig.title,
        link,
        desc: this.configurationData.desc || this.shareConfig.desc, // 分享标题，默认为活动页面标题（可手动调整）, //分享活动简介
        icon: this.configurationData.icon || this.shareConfig.icon, // 分享后朋友看到的图标
        callback: this.callBack(),
      });
      this.reportFunc('share', {});
    },
    reportFunc(key, eventData) {
      if (typeof  this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: key,
          eventData,
        };
        this.reportClickRaw(params);
        console.log(`reportFunc ${key}  report data =`, params);
      }
    },
    async callBack() {
      console.log('run  doShare callback and this.callBackFlowId = ', this.callBackFlowId);
      if (this.callBackFlowId > 0) {
        const response = await this.flowRequest({
          flowId: this.callBackFlowId,
          params: {
            role: this.roleInfo,
          },
        });
        console.log('share callback ', this.callBackFlowId, response);
      }
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
